'use client'

import { useTranslations } from "next-intl"
import AppLink, { AppLinkSize } from "../UI/Links/AppLink/AppLink"

export default function FooterHelpCenterLink () {
  const t = useTranslations('Footer')
  const helpCenterLink = process.env.NEXT_PUBLIC_HELP_CENTER_LINK ?? ''
  const hasExternalLink = helpCenterLink.length > 0

  return (
    <AppLink
      href={hasExternalLink ? helpCenterLink : undefined}
      target={hasExternalLink ? '_blank' : undefined}
      size={AppLinkSize.S}
      internal={false}
      onClick={
        hasExternalLink
          ? undefined
          : () => { window.fcWidget.open() }
      }
    >
      {t('helpCenterLink')}
    </AppLink>
  )
}